import { Result } from '@cplug/frontend-core/utils'
import type { StagingAccountActivation } from '../models/StagingAccountActivation'
import {
  StagingAccountActivationResponseDTO,
  mapDTOToStagingAccountActivation,
  type StagingAccountActivationDTO
} from './DTOs/StagingAccountActivationDTO'
import { CPBaseGateway } from '~/shared/gateways'

export class CPStagingAccountActivationGateway extends CPBaseGateway {
  protected apiUrlDomain = 'my-plan/staging-activation'

  async getStatus (): Promise<Result<StagingAccountActivation>> {
    const response = await this.get<{ data: StagingAccountActivationDTO }>(this.apiUrlDomain)

    return this.parseResponse(
      response,
      StagingAccountActivationResponseDTO,
      dto => Result.ofValue(mapDTOToStagingAccountActivation(dto.data))
    )
  }

  async activate (): Promise<Result<StagingAccountActivation>> {
    const response = await this.post<{ data: StagingAccountActivationDTO }>(this.apiUrlDomain)

    return this.parseResponse(
      response,
      StagingAccountActivationResponseDTO,
      dto => Result.ofValue(mapDTOToStagingAccountActivation(dto.data))
    )
  }
}
